export const onLoadAccount = payload => ({
    type: 'ON_LOAD_ACCOUNT',
    payload,
})



// WEBPACK FOOTER //
// ./src/actions/settingAcountAction.js